import React from "react";
import { Box, SpaceBetween } from "@amzn/awsui-components-console";
import { TaskStatus } from "src/constants/commonEnums";
import { StatusIndicator } from "./statusIndicator";
import "src/components/selfServeWorkflows/executionView/execution-view.scss";

function TaskNodeLegend(props) {
  return (
    <Box display="inline">
      <SpaceBetween direction="horizontal" size="s">
        {Object.values(TaskStatus).map((val) => (
          <StatusIndicator key={val} taskStatus={val} noOfTasks={props[val]} />
        ))}
      </SpaceBetween>
    </Box>
  );
}

export default TaskNodeLegend;
